/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { EntityFinderDialog, EntityFinderParams, ISortModel, StatusService } from '@core';

import { AccountPurchaseOrder } from '@models';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UtilFns } from '@utils';

export interface AccountPurchaseOrderFinderParams extends EntityFinderParams {
  accountPurchaseOrders: AccountPurchaseOrder[];
}

@Component({
  selector: 'prox-puchase-order-finder',
  template: EntityFinderDialog.HTML,
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class AccountPurchaseOrderFinderDialog extends EntityFinderDialog<AccountPurchaseOrder, AccountPurchaseOrderFinderParams> {
  params!: AccountPurchaseOrderFinderParams;

  constructor(
    ref: DynamicDialogRef,
    override config: DynamicDialogConfig<AccountPurchaseOrderFinderParams>,

    private statusService: StatusService,
  ) {
    super(ref, config);
    UtilFns.assertNonNull(config.data);
    this.params = config.data;
  }

  override async initialize() {
    return {
      header: 'Select a Purchase Order',
      width: 'calc(40vw)',
    };
  }

  override async initDatasource() {
    return this.params.accountPurchaseOrders;
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Purchase Order', field: 'purchaseOrder' },
      { headerName: 'Start Date', field: 'startDate', filter: 'agDateColumnFilter' },
      {
        headerName: 'End Date',
        field: 'endDate',
        filter: 'agDateColumnFilter',
      },
      { headerName: 'Amount', field: 'amt', filter: 'agNumberColumnFilter' },
      // {
      //   headerName: 'Amount Used',
      //   filter: 'agNumberColumnFilter',
      //   valueGetter: (params) => {
      //     const x = params.data as AccountPurchaseOrder;
      //     if (x == null) return;
      //     return _.sumBy(x.accountPurchaseOrderLogs, (y) => y.amt);
      //   },
      //   colId: 'usedAmt', // HACK: colId endsWith amt triggers $ formatting.
      // },
      // ,
      // { headerName: 'Parent Purchase Order', field: 'parentPurchaseOrder.purchaseOrder', editable: false,  },
    ];
    const sortModel = [{ colId: 'purchaseOrder', sort: 'asc' }] as ISortModel;
    return [colDefs, sortModel] as const;
  }
}
